// extracted by mini-css-extract-plugin
module.exports = {"cardDetail__companyName":"cardDetail__companyName"};